// extracted by mini-css-extract-plugin
export var badge = "_hz-2";
export var detailsPanel = "_hz-0";
export var resultRow = "_hz-1";